// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-transfer[data-v-2d719f35]{\n  margin-top:10px;\n}\n", ""]);
// Exports
module.exports = exports;
